<template>
  <div class="h-100 hvh-flex center p-5">
    <v-form class="col-12 col-lg-6 mt-5" @submit.prevent="submit" ref="form">
      <v-text-field v-model="password" :append-icon="passwordHide ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (passwordHide = !passwordHide)" :type="passwordHide ? 'password' : 'text'" name="Password" label="Password" />

      <v-btn flat block large class="hvh-btn hvh-btn--primary mt-5" @click="submit">Enter</v-btn>
    </v-form>
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import axios from '../../axios';
import Loader from '../../components/common/loader/Loader.vue';
import { createFormData, errorDebug } from '../../libraries/common';
export default {
  components: { Loader, },
  data() {
    return {
      password: '',
      passwordHide: true,
      isLoading: false,
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      axios.post(`/api/ITM/CustomerAccess/${this.token}/LogIn`, createFormData({ password: this.password, }))
        .then(({ data }) => {
          sessionStorage.setItem('customerToken', data.jwtToken);
          this.$router.replace({ name: 'itmCustomerAccess', params: { token: this.token } });
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomerAccessLogIn'] = this;
  },
}
</script>
